import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";
import { checkAndThrowRequiredFieldsError } from "@/utils/errors";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/access_levels";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const accessLevelsSchema: DataProviderSchema<"AccessLevel", "jsonld"> = {
  list: getLocalFilteredSortedList(fetchListData),
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Access Level not found");

    return {
      data,
    };
  },
  edit: async ({ id, data: { title, name, level } }) => {
    const requiredFields = ["title", "name"];

    const body = checkAndThrowRequiredFieldsError(
      { title, name, level },
      requiredFields,
    );
    const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body,
    });

    if (!data) throw Error("Something went wrong");

    return {
      data,
    };
  },
  create: async ({ data: { title, name, level } }) => {
    const requiredFields = ["title", "name"];

    const body = checkAndThrowRequiredFieldsError(
      { title, name, level },
      requiredFields,
    );
    const { data } = await apiClient.POST(BASE_URL, {
      body,
    });

    if (!data) throw Error("Something went wrong");

    return {
      data,
    };
  },
};
